import { useState } from 'react'
import emailjs from '@emailjs/browser'
import { toast } from 'sonner'

import Title from '../components/items/Title'

import styles from './contact.module.css'

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [msg, setMsg] = useState('')

  function sendEmail(e) {
    e.preventDefault()

    const templateParams = {
      from_name: name,
      message: msg,
      email: email,
      phone: phone
    }

    emailjs
      .send(
        'service_5x8bman',
        'template_6ctsrng',
        templateParams,
        'k9tvPkQ1DGlpzD7kw'
      )
      .then(
        response => {
          toast.success('E-mail enviado com sucesso!')
          setName('')
          setEmail('')
          setPhone('')
          setMsg('')
        },
        error => {
          toast.error('Falha no envio do e-mail!')
        }
      )
  }

  return (
    <section id="Contact" className={styles.containerContact}>
      <Title title="FALE" subTitle="COMIGO." />
      <form className={styles.form} onSubmit={sendEmail}>
        <input
          className={styles.imput}
          type="text"
          name=""
          id=""
          placeholder="Seu nome completo:"
          required
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <input
          className={styles.imput}
          type="text"
          name=""
          id=""
          placeholder="Seu e-mail:"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          className={styles.imput}
          type="text"
          name=""
          id=""
          placeholder="Seu celular:"
          required
          value={phone}
          onChange={e => setPhone(e.target.value)}
        />
        <textarea
          className={styles.imput}
          name=""
          id=""
          cols="30"
          rows="10"
          placeholder="Sua mensagem"
          required
          value={msg}
          onChange={e => setMsg(e.target.value)}
        ></textarea>
        <div className={styles.btnEnviar}>
          <input className={styles.imputBtn} type="submit" value="ENVIAR" />
        </div>
      </form>
    </section>
  )
}
